var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center no-result mt-7"},[_c('img',{staticClass:"mb-2",attrs:{"src":require("@/assets/images/common/warning.png"),"alt":"!"}}),(_vm.searchText === '')?_c('p',[_vm._v(" 데이터가 없습니다. ")]):_c('p',[_vm._v(" 검색결과가 없습니다. "),_c('br'),_vm._v(" 다시 검색해주시기 바랍니다. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }